import React, { useEffect } from 'react';
import { VendorType } from 'models/vendors.model';
import { Input } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';

const UpdateVendorDetails = ({
  vendor,
  setVendor
}: {
  vendor: VendorType;
  setVendor: (arg1: VendorType) => void;
}) => {
  const formatPaymentPeriod = (value: string | number) => {
    const numberOfDays = Number(
      String(value)
        .replace(/\s*days?$/i, '')
        .trim()
    );

    if (Number.isNaN(numberOfDays) || numberOfDays <= 0) return String(value);

    return `${numberOfDays} day${numberOfDays === 1 ? '' : 's'}`;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'payment_period') {
      setVendor({ ...vendor, [name]: formatPaymentPeriod(value) });
      return;
    }

    setVendor({ ...vendor, [name]: value });
  };

  useEffect(() => {
    const formattedPaymentPeriod = formatPaymentPeriod(vendor.payment_period);

    if (vendor.payment_period !== formattedPaymentPeriod) {
      setVendor({ ...vendor, payment_period: formattedPaymentPeriod });
    }
  }, [vendor.payment_period]);
  const daysArray: { id: string; name: string }[] = [];

  for (let i = 1; i <= 30; i++) {
    daysArray.push({
      id: i.toString(),
      name: `${i} day${i > 1 ? 's' : ''}`
    });
  }

  return (
    <div>
      <div className='grid grid-cols-2 gap-4'>
        <Input
          design='bordered'
          name='name'
          value={vendor.name}
          label='Vendor name'
          placeholder='Femite foodco ltd'
          onChange={(e) => handleChange(e)}
        />
        <Input
          design='bordered'
          name='phone'
          type='tel'
          value={vendor.phone_number}
          label='Phone number'
          placeholder='081 476 5411'
          onChange={(e) => handleChange(e)}
        />

        <Input
          design='bordered'
          name='bank_name'
          value={vendor.bank_name}
          label='Bank name'
          placeholder='Femite foodco ltd'
          onChange={(e) => handleChange(e)}
        />
        <Input
          design='bordered'
          name='account_number'
          type='tel'
          value={vendor.account_number}
          label='Account number'
          placeholder='381476541'
          onChange={(e) => handleChange(e)}
        />
      </div>
      <Input
        className='mt-4'
        design='bordered'
        name='account_name'
        value={vendor.account_name}
        label='Account name'
        placeholder='e.g Femite food & drinks'
        onChange={(e) => handleChange(e)}
      />
      <div className='mt-4'></div>
      <SelectDropdown
        label='Vendor payment period'
        placeholder='Select payment period'
        value={vendor.payment_period}
        setValue={(item) => {
          handleChange({ target: { name: 'payment_period', value: item.name } });
        }}
        options={daysArray}
      />
    </div>
  );
};

export default UpdateVendorDetails;
